var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M880.11 799.74C677.05 528.17 293.64 461.17 0 617.81c216.26-237.78 770.45-438 1013.2-150.2 12.34 17.36 14.61 31.75 4.19 52.38-47.87 92.7-88.56 187.28-137.28 279.75z",
    fill: "#38317e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.43 342.68c76.88-87.13 206.51-105.9 308.57-55.21 13 5.9 24 6.46 36.88-.91C646.17 224.81 799 192.61 916.44 258.9c30.16 23.75 35.39 59.83 11.72 84.34-3.37 3.5-12.67 5.84-16.41 3.73-150.75-77.28-329.57-49.78-486.53-7.26-74.43 16.34-109.06-46.23-237.79 2.97z",
    fill: "#54b62b"
  })));
}
export default SvgBh;